<template>
  <div :class="{ 'svg-icon-auto': auto, 'svg-icon-limit': !auto }" @click="$emit('click')">
    <el-tooltip v-if="tooltip" :content="content" :placement="placement">
      <svg :class="svgClass" aria-hidden="true">
        <use :xlink:href="iconName"></use>
      </svg>
    </el-tooltip>

    <svg v-else :class="svgClass" aria-hidden="true">
      <use :xlink:href="iconName"></use>
    </svg>
    <span class="svg-icon">
      <slot />
    </span>
  </div>
</template>

<script>
export default {
  name: "svg-icon",
  props: {
    tooltip: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      defaullt: ""
    },
    placement: {
      type: String,
      default: "top"
    },
    //svg相关配置
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String
    },
    auto: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    svgClass() {
      let pre = "svg-icon ";
      if (this.className) {
        return pre + this.className;
      } else {
        return pre;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@mixin main {
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
//自动计算宽高
.svg-icon-auto {
  position: relative !important;
  overflow: hidden;
  height: 100%;
  .svg-icon {
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    @include main;
  }
  .svg-icon::before {
    content: "";
    padding-top: 100%;
    display: block;
  }
}
.svg-icon-limit {
  display: inline-block;
  .svg-icon {
    width: 14px;
    height: 14px;
    @include main;
  }
}
</style>